 document.addEventListener('DOMContentLoaded', function () {
    const videoCarousel = document.querySelector('.cus-video-carousel');
    const arrowLeft = document.querySelector('.cus-arrow-left');
    const arrowRight = document.querySelector('.cus-arrow-right');
    const videos = document.querySelectorAll('[data-video-element]');
    const playButtons = document.querySelectorAll('.cus-play-button');
    const muteButtons = document.querySelectorAll('[data-mute-button]');
    const videoItems = document.querySelectorAll('.cus-video-item');
    const cartButtons = document.querySelectorAll('[data-cart-button]');
    const modal = document.getElementById('video-caro-modal');
    const modalContent = document.getElementById('video-caro-modal-content');
    const modalClose = modal.querySelector('.video-caro-modal-close');

    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    function scrollToNextItem(direction) {
      const firstItem = videoItems[0];
      if (!firstItem) return;

      const itemWidth = firstItem.offsetWidth;
      const gap = parseInt(getComputedStyle(videoCarousel).gap) || 25;
      const scrollAmount = itemWidth + gap;

      let scrollPosition = videoCarousel.scrollLeft;
      const maxScroll = videoCarousel.scrollWidth - videoCarousel.clientWidth;

      if (direction === 'left') {
        scrollPosition = Math.max(0, scrollPosition - scrollAmount);
      } else {
        scrollPosition = Math.min(maxScroll, scrollPosition + scrollAmount);
      }

      videoCarousel.scrollTo({
        left: scrollPosition,
        behavior: 'smooth',
      });

      setTimeout(() => {
        updateArrowVisibility();
      }, 300);
    }

    arrowLeft.addEventListener('click', () => scrollToNextItem('left'));
    arrowRight.addEventListener('click', () => scrollToNextItem('right'));

    function updateArrowVisibility() {
      const scrollLeft = videoCarousel.scrollLeft;
      const maxScroll = videoCarousel.scrollWidth - videoCarousel.clientWidth;

      arrowLeft.style.opacity = scrollLeft > 10 ? '1' : '0';
      arrowLeft.style.visibility = scrollLeft > 10 ? 'visible' : 'hidden';

      arrowRight.style.opacity = scrollLeft < maxScroll - 10 ? '1' : '0';
      arrowRight.style.visibility = scrollLeft < maxScroll - 10 ? 'visible' : 'hidden';
    }

    videoCarousel.addEventListener('scroll', () => {
      updateArrowVisibility();
      pauseHiddenVideos();
    });

    function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    muteButtons.forEach((button, index) => {
      const video = videos[index];
      const muteIcon = button.querySelector('.mute-icon');
      const unmuteIcon = button.querySelector('.unmute-icon');

      button.addEventListener('click', function (e) {
        e.stopPropagation();

        video.muted = !video.muted;

        if (video.muted) {
          button.classList.remove('active');
          muteIcon.style.display = 'block';
          unmuteIcon.style.display = 'none';
        } else {
          button.classList.add('active');
          muteIcon.style.display = 'none';
          unmuteIcon.style.display = 'block';
        }
      });

      if (!video.muted) {
        button.classList.add('active');
        muteIcon.style.display = 'none';
        unmuteIcon.style.display = 'block';
      }
    });

    cartButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        
        const videoItem = this.closest('.cus-video-item');
        if (videoItem && videoItem.classList.contains('playing')) {
          const video = videoItem.querySelector('video');
          if (video && !video.paused) {
            video.pause();
            videoItem.classList.remove('playing');
          }
        }

        const template = document.querySelector(`[data-product-template="${this.dataset.cartButton}"]`);
        if (template) {
          modalContent.innerHTML = template.innerHTML;
          modal.classList.add('active');
        }
      });
    });

    modalClose.addEventListener('click', function () {
      modal.classList.remove('active');
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });

    function setupTouchDevicePlayback() {
      videoItems.forEach((item, index) => {
        const video = videos[index];
        const container = item.querySelector('.cus-video-container');
        const playButton = playButtons[index];
        const playIcon = playButton.querySelector('svg');

        playButton.addEventListener('touchstart', function (e) {
          e.stopPropagation();
          e.preventDefault();

          video.style.display = 'block';

          video
            .play()
            .then(() => {
              item.classList.add('playing');
              playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
            })
            .catch((error) => {
              console.error('Mobile playback error:', error);
            });
        });

        playButton.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();

          video.style.display = 'block';
          video.play().then(() => {
            item.classList.add('playing');
            playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
          });
        });

        container.addEventListener('click', function (e) {
          if (!e.target.closest('.cus-play-button') && 
              !e.target.closest('.cus-mute-button') && 
              !e.target.closest('.video-caro-cart-button')) {
            if (!video.paused) {
              video.pause();
              item.classList.remove('playing');
              playIcon.innerHTML = '<path d="M6.5 5.5A.5.5 0 0 1 7 5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-9zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-9z"/>';
            }
          }
        });
      });
    }

    function setupDesktopPlayback() {
      videoItems.forEach((item, index) => {
        const video = videos[index];
        const container = item.querySelector('.cus-video-container');
        const playButton = playButtons[index];
        const playIcon = playButton.querySelector('svg');

        container.addEventListener('mouseenter', function () {
          if (video.paused && !item.classList.contains('ended')) {
            video.style.display = 'block';
            video.play().catch((e) => console.log('Play error:', e));
            item.classList.add('playing');
            playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
          }
        });

        container.addEventListener('mouseleave', function () {
          if (!video.paused && !item.classList.contains('ended')) {
            video.pause();
          }
        });

        container.addEventListener('click', function (e) {
          if (e.target.closest('.cus-play-button') || 
              e.target.closest('.cus-mute-button') || 
              e.target.closest('.video-caro-cart-button')) {
            return;
          }

          if (video.paused) {
            video.style.display = 'block';
            video.play().catch((e) => console.log('Play error:', e));
            item.classList.add('playing');
            item.classList.remove('ended');
            playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
          } else {
            video.pause();
            item.classList.remove('playing');
            playIcon.innerHTML = '<path d="M6.5 5.5A.5.5 0 0 1 7 5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-9zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-9z"/>';
          }
        });
      });
    }

    function setupCommonPlayback() {
      playButtons.forEach((button, index) => {
        const video = videos[index];
        const item = videoItems[index];
        const playIcon = button.querySelector('svg');

        button.addEventListener('click', function (e) {
          if (video.paused) {
            video.style.display = 'block';
            video.play().catch((e) => console.log('Play error:', e));
            item.classList.add('playing');
            item.classList.remove('ended');
            playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
          } else {
            video.pause();
            item.classList.remove('playing');
            playIcon.innerHTML = '<path d="M6.5 5.5A.5.5 0 0 1 7 5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-9zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-9z"/>';
          }
        });
      });

      videos.forEach((video, index) => {
        const item = videoItems[index];
        const playIcon = playButtons[index].querySelector('svg');

        video.addEventListener('play', function () {
          item.classList.add('playing');
          item.classList.remove('ended');
          playIcon.innerHTML = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';
        });

        video.addEventListener('ended', function () {
          item.classList.add('ended');
          item.classList.remove('playing');
          playIcon.innerHTML = '<path d="M6.5 5.5A.5.5 0 0 1 7 5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-9zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-9z"/>';
        });
      });
    }

    function pauseHiddenVideos() {
      const carouselRect = videoCarousel.getBoundingClientRect();

      videos.forEach((video, index) => {
        const item = videoItems[index];
        const itemRect = item.getBoundingClientRect();

        const isVisible = itemRect.right > carouselRect.left + 50 && itemRect.left < carouselRect.right - 50;

        if (!isVisible && !video.paused) {
          video.pause();
        }
      });
    }

    function handleAddToCart(variantId, button) {
      if (!variantId) {
        console.error('Product variant ID missing');
        return;
      }

      const originalText = button.innerHTML;
      button.innerHTML = 'Adding...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      })
        .then((res) => {
          if (!res.ok) throw new Error();
          document.dispatchEvent(new Event('cart:refresh'));
          button.innerHTML = 'Added!';
          setTimeout(() => {
            button.innerHTML = originalText;
            button.disabled = false;
          }, 2000);
        })
        .catch(() => {
          alert('Error adding to cart');
          button.innerHTML = originalText;
          button.disabled = false;
        });
    }

    function handleBuyNow(variantId, button) {
      if (!variantId) {
        console.error('Product variant ID missing');
        return;
      }

      const originalText = button.innerHTML;
      button.innerHTML = 'Processing...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      })
        .then((res) => {
          if (res.ok) {
            window.location.href = '/checkout';
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          alert('Error adding to cart');
          button.innerHTML = originalText;
          button.disabled = false;
        });
    }

    modalContent.addEventListener('click', function (e) {
      const addCartButton = e.target.closest('.video-caro-add-cart-button');
      const buyNowButton = e.target.closest('.video-caro-buy-now-button');

      if (addCartButton) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = addCartButton.getAttribute('data-product-variant-id');
        handleAddToCart(variantId, addCartButton);
        return;
      }

      if (buyNowButton) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = buyNowButton.getAttribute('data-product-variant-id');
        handleBuyNow(variantId, buyNowButton);
        return;
      }
    });

    updateArrowVisibility();

    if (isTouchDevice()) {
      setupTouchDevicePlayback();
    } else {
      setupDesktopPlayback();
    }

    setupCommonPlayback();

    window.addEventListener('resize', function () {
      setTimeout(() => {
        updateArrowVisibility();
        pauseHiddenVideos();
      }, 250);
    });
  });